var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrendlyLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3908 14.4413H16.1246L14.5868 15.3959C13.4591 18.7491 12.221 21.1437 11.6532 20.974C10.9848 20.7768 11.456 17.1968 12.7079 12.9777C13.9599 8.75865 15.5134 5.50016 16.1818 5.6974C16.7456 5.86506 16.4933 8.45883 15.6455 11.7962L17.2385 13.0152H25.1247L26.6723 11.9619C26.2555 8.58598 24.5689 5.4957 21.9556 3.31973C19.3422 1.14375 15.9985 0.0455197 12.6045 0.248454C9.21057 0.451389 6.02136 1.94024 3.68567 4.41214C1.34998 6.88403 0.0432622 10.1533 0.0313324 13.5549C0.0194026 16.9564 1.30316 20.2348 3.62145 22.723C5.93974 25.2112 9.11843 26.7224 12.5109 26.9492C15.9033 27.176 19.2547 26.1012 21.8832 23.9437C24.5118 21.7861 26.22 18.7077 26.6605 15.3348L25.3908 14.4413Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrendlyLogoWhite);
export default __webpack_public_path__ + "static/media/crendly-logo-white.b64ffafb9ccb012fe281fdcfd5fe7f0d.svg";
export { ForwardRef as ReactComponent };